module.exports = __webpack_public_path__ + "static/media/hero.198cb507.png";